import { z } from 'zod';

export const agentTemplateSchema = z.object({
  agent_template: z.object({
    name: z.string({ message: 'Name is required' }),
    agent_name: z.string({ message: 'Agent name is required' }),
    languages: z.array(z.string({ message: 'Language is required' })),
    instructions: z.string({ message: 'Instructions are required' }),
    voice_id: z.string({ message: 'Voice is required' }),
    agent_type: z.string({ message: 'Agent Type is required' }),
    tone: z.string({ message: 'Tone is required' }),
    goal: z.string({ message: 'Goal is required' }),
    background: z.string({ message: 'Background is required' }),
    welcome_message: z.string({ message: 'Welcome message is required' }),
    description: z.string({ message: 'Description is required' }),
    physical_location_exists: z.any().optional(),
    industry: z.string({ message: 'Industry is required' })
  })
});
